import ConfirmMembership from './ConfirmMembershipContainer';

export default ConfirmMembership;
